import httpClient from 'api/httpClient';
import { RestockListItem } from 'models/RestockListItem';

const getRestockList = (params?: { storeNo: number }) =>
  httpClient.get<RestockListItem[]>('admin-products/fill-reports', {
    params,
  });

export default { getRestockList };
